import * as types from '../actiontypes';

export function setBookmarkAction(
	requestUrl,
	baseUrl,
	taskdata,
	data,
	workspaceid
) {
	return {
		type: types.SET_TASK_BOOKMARK,
		meta: {
			api: {
				url: requestUrl,
				method: 'PATCH',
				data: data
			},
			url: baseUrl,
			tasks: taskdata,
			workspaceId: workspaceid
		}
	};
}

export function getBookmarkAction(requestUrl, baseUrl, workspaceid) {
	return {
		type: types.GET_BOOKMARK_TASKS,
		meta: {
			api: {
				url: requestUrl,
				method: 'GET'
			},
			url: baseUrl,
			workspaceId: workspaceid
		}
	};
}

export function unBookmarkAction(taskIds, baseUrl) {
	return {
		type: types.UNBOOKMARK_TASK,
		taskIds: taskIds,
		url: baseUrl
	};
}
